import { UserCheck, Activity, TrendingUp, CircleSlash, ShieldCheck, SlidersHorizontal, MonitorCheck } from "lucide-react";
import { FEATURES } from "../../data/content";
import { Reveal, SectionHeading } from "./Reveal";

const ICONS = { UserCheck, Activity, TrendingUp, CircleSlash, ShieldCheck, SlidersHorizontal };

const WhyMedlyn = () => (
  <section id="why-medlyn" className="bg-brand-sky-soft dark:bg-[#0C1338] py-24 md:py-32" data-testid="why-medlyn-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeading
        id="why-medlyn"
        overline="Why Medlyn 360"
        title={<>Built like a clinical service. <span className="text-brand-gradient">Not a software tool.</span></>}
        sub="Every detail of Medlyn 360 is designed around one outcome: physicians spending their working hours on medicine, not on keyboards."
      />
      <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {FEATURES.map((f, i) => {
          const Icon = ICONS[f.icon];
          return (
            <Reveal key={f.title} delay={(i % 3) * 0.08}>
              <div
                className="group h-full rounded-3xl bg-white dark:bg-white/5 border border-slate-100 dark:border-white/10 p-8 hover:shadow-[0_24px_60px_-30px_rgba(42,49,146,0.4)] hover:-translate-y-1 transition-[transform,box-shadow] duration-300"
                data-testid={`feature-card-${i}`}
              >
                <div className="w-12 h-12 rounded-2xl bg-brand-sky-soft dark:bg-white/10 flex items-center justify-center mb-6 group-hover:bg-brand-navy dark:group-hover:bg-brand-sky transition-colors duration-300">
                  <Icon size={20} className="text-brand-navy dark:text-brand-sky group-hover:text-white dark:group-hover:text-brand-ink transition-colors duration-300" />
                </div>
                <h3 className="font-display text-xl font-semibold text-slate-900 dark:text-white mb-3">{f.title}</h3>
                <p className="text-sm leading-relaxed text-slate-500 dark:text-slate-400">{f.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
      <Reveal delay={0.1}>
        <div
          className="mt-6 relative overflow-hidden rounded-3xl bg-gradient-to-br from-brand-navy to-brand-navy-deep p-8 md:p-10 grid md:grid-cols-[auto_1fr] gap-6 md:gap-8 items-center"
          data-testid="ehr-compatibility-banner"
        >
          <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-brand-sky/20 blur-3xl" />
          <div className="relative w-14 h-14 rounded-2xl bg-white/10 border border-white/15 flex items-center justify-center shrink-0">
            <MonitorCheck size={24} className="text-brand-sky" />
          </div>
          <div className="relative">
            <h3 className="font-display text-xl md:text-2xl font-semibold text-white" data-testid="ehr-banner-title">
              Works With Your Existing EHR
            </h3>
            <p className="mt-2.5 max-w-3xl text-sm md:text-base leading-relaxed text-white/70" data-testid="ehr-banner-desc">
              Our scribes adapt to your existing clinical workflow and work across all major EHR platforms—so there's
              no need to change the systems your practice already uses.
            </p>
            <div className="mt-5 flex flex-wrap gap-2.5" data-testid="ehr-logo-strip">
              {["Epic", "Oracle Health (Cerner)", "athenahealth", "eClinicalWorks", "NextGen", "Veradigm (Allscripts)", "Practice Fusion", "+ more"].map((n) => (
                <span
                  key={n}
                  data-testid={`ehr-chip-${n.split(" ")[0].replace(/\W/g, "").toLowerCase() || "more"}`}
                  className="rounded-full border border-white/15 bg-white/[0.06] px-4 py-1.5 text-[11px] font-bold tracking-wide text-white/80"
                >
                  {n}
                </span>
              ))}
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
export default WhyMedlyn;
